export const EXTERNAL_LINKS = {
  CHAT_UWM: 'https://chatuwm.uwm.com/',
  BOLT_INCIDENT:
    'https://uwm.service-now.com/esc?id=sc_cat_item&sys_id=6587228ffb059a10f87efaaf3eefdcf7&sysparm_category=e15706fc0a0a0aa7007fc21e1ab70c2f&sysparm_variable_values=%7B"u_loan_number":"{loanNumber}"%7D',
  SUBMIT_ISSUE_BASE: 'https://ask.uwm.com/s/client-request',
  SUGGEST_IDEAS: 'https://uwm.az1.qualtrics.com/jfe/form/SV_5yFqAZwivqtDkLY',
};

export const buildBoltIncidentUrl = (params: {
  loanNumber?: string | number;
}) => {
  if (params.loanNumber) {
    const loanNumber = encodeURIComponent(String(params.loanNumber));

    return EXTERNAL_LINKS.BOLT_INCIDENT.replace('{loanNumber}', loanNumber);
  }

  return EXTERNAL_LINKS.BOLT_INCIDENT.replace(
    '&sysparm_variable_values=%7B"u_loan_number":"{loanNumber}"%7D',
    '',
  );
};

export const buildSubmitIssueUrl = (params: {
  loanNumber?: string | number;
  loanStatus?: string;
  obfuscatedLoanRecordId?: string | number;
}) => {
  const searchParams = new URLSearchParams({
    loanid: String(params.loanNumber ?? '0000000000'),
    loanstatus: params.loanStatus ?? 'General',
    eid: String(params.obfuscatedLoanRecordId ?? ''),
  });

  return `${EXTERNAL_LINKS.SUBMIT_ISSUE_BASE}?${searchParams.toString()}`;
};
